import { Dayjs } from "dayjs";
import dayjs from "dayjs";

export interface TimeValidationResult {
    error?: string;
}

export const createDateTime = (date: string, time: string, format: string, timeFormat: string): Dayjs => {
    return dayjs(`${date} ${time}`, `${format} ${timeFormat}`);
};

export const getInitialTimes = (dateFormat: string, timeFormat: string) => {
    const now = dayjs();
    // Round up to the next 15-minute interval for start time
    const minutes = now.minute();
    const roundTo = 15;
    const remainder = minutes % roundTo;
    const minutesToAdd = remainder === 0 ? roundTo : roundTo - remainder;
    const roundedStartTime = now.add(minutesToAdd, "minute").second(0);

    // Set end time to one hour after the rounded start time
    const roundedEndTime = roundedStartTime.add(1, "hour");

    return {
        startDate: roundedStartTime.format(dateFormat),
        startTime: roundedStartTime.format(timeFormat),
        endDate: roundedEndTime.format(dateFormat),
        endTime: roundedEndTime.format(timeFormat),
    };
};

export const DEFAULT_TIME_FORMAT = "hh:mm a";
